export default __webpack_public_path__ + "static/media/unilever.d3168c11.jpg";